import {
  loadTurnstile,
  removeTurnstile,
  renderTurnstile,
  resetTurnstile,
} from '../turnstileRuntime'
import type {
  BotProtectionProviderAdapter,
  BotProtectionWidgetInstance,
} from './types'
import { resolveTurnstileWidgetConfig } from './turnstileConfig'
import { toAdapterRuntimeEvent, toTurnstileCallbacks } from './turnstileEvents'

type TurnstileRenderInput = Parameters<BotProtectionProviderAdapter['renderWidget']>[0]

export const renderTurnstileBotProtectionWidget = async ({
  container,
  clientConfig,
  callbacks,
  onRuntimeEvent,
}: TurnstileRenderInput): Promise<BotProtectionWidgetInstance> => {
  const config = resolveTurnstileWidgetConfig({ clientConfig, onRuntimeEvent })

  await loadTurnstile({
    onEvent: (event) => {
      onRuntimeEvent?.(toAdapterRuntimeEvent(event))
    },
  })

  const widgetId = await renderTurnstile(
    container,
    {
      sitekey: config.siteKey,
      'retry': 'never',
      'refresh-expired': 'manual',
      'refresh-timeout': 'manual',
      ...(config.challengeMode === 'invisible' ? { size: 'invisible' } : {}),
      ...toTurnstileCallbacks(callbacks),
    },
    {
      onEvent: (event) => {
        onRuntimeEvent?.(toAdapterRuntimeEvent(event))
      },
    },
  )

  return {
    reset: () => resetTurnstile(widgetId),
    destroy: () => removeTurnstile(widgetId),
  }
}
